import { Recipient } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { Recipient as MetlRecipient } from '@weave/schema-gen-ts/dist/schemas/messaging/etl/bulk/v1/service.pb';
import { dedupeRecipients } from './dedupe-recipients';

/**
 * Converts a recipient from the messaging ETL bulk schema `Recipient` to the messaging bulk schema `Recipient` type.
 * @param recipient - The recipient to convert.
 * @param campaignId - The campaign ID to associate with the recipient.
 * @returns The converted recipient.
 */

export const convertRecipients = (metlRecipients: MetlRecipient[], campaignId: string) => {
  const recipients: Recipient[] = metlRecipients.map((metlRecipient) => ({
    campaignId,
    destination: metlRecipient.destination ?? '',
    firstName: metlRecipient.firstName ?? '',
    lastName: metlRecipient.lastName ?? '',
    locationId: metlRecipient.locationId ?? '',
    personId: metlRecipient.personId,
    preferredName: metlRecipient.preferredName ?? '',
  }));
  return dedupeRecipients(recipients);
};
